/**
 * @classdesc Exceção de negócio padrão.
 */
export default class BusinessError extends Error {
    /**
     * @param {string | undefined} message - A human-readable description of the error.
     * @param {ErrorOptions | undefined} [options=undefined] - An object that has the following properties: cause, fileName, lineNumber.
     */
    constructor(message, options = undefined) {
        super(message, options);
        this.name = 'Erro de negócio';
        this.stack = new Error().stack;
    }
}
